import { render, staticRenderFns } from "./community-guidelines.vue?vue&type=template&id=4b73061a&scoped=true&"
import script from "./community-guidelines.vue?vue&type=script&lang=js&"
export * from "./community-guidelines.vue?vue&type=script&lang=js&"
import style0 from "./community-guidelines.vue?vue&type=style&index=0&id=4b73061a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b73061a",
  null
  
)

export default component.exports